import React from "react";
import { XCircle } from "react-feather";
import "./ErrorBoundary.scss";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo);
  }

  handleRefresh = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          <div className="error-boundary__container">
            <XCircle 
              className="error-boundary__icon"
              size={64}
              strokeWidth={2}
            />
            <h1 className="error-boundary__heading">
              An Error Has Occurred
            </h1>
            <p className="error-boundary__message">
              In order to continue, please refresh the page. If the error
              happens again, please contact{" "}
              <a 
                href="mailto:oasity-support@ibp.fraunhofer.de"
                className="error-boundary__email"
              >
                oasity-support@ibp.fraunhofer.de
              </a>
              .
            </p>
            <button 
              className="error-boundary__button"
              onClick={this.handleRefresh}
            >
              Refresh Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
